import { tokenLogos } from '@/config/chain/configs/mainnet/assets'
import { InternalLinkButton } from '@/ui/atoms/link-button/LinkButton'
import { Panel } from '@/ui/atoms/panel/Panel'
import { IconStack } from '@/ui/molecules/icon-stack/IconStack'
import { cn } from '@/ui/utils/style'

const TOKEN_ICON_PATHS = [tokenLogos.usds, tokenLogos.wsteth, tokenLogos.eth, tokenLogos.usdc, tokenLogos.dai]

interface CreatePositionPanelProps {
  className?: string
}

export function CreatePositionPanel({ className }: CreatePositionPanelProps) {
  return (
    <Panel className={cn('flex flex-col gap-6 text-center', className)}>
      <div className="flex flex-col items-center gap-6 text-center">
        <IconStack items={TOKEN_ICON_PATHS} size="lg" stackingOrder="first-on-top" />
        <div className="typography-heading-4 sm:typography-heading-3 max-w-[30ch]">
          Use our Easy Borrow Flow to quickly deposit your assets and borrow DAI
        </div>
      </div>
      <InternalLinkButton to="/borrow">Create position</InternalLinkButton>
    </Panel>
  )
}
